<div class="container">
  <div class="error-message">
    {{ data?.text }}
  </div>
</div>
